module.exports = __webpack_public_path__ + "statics/img/cate6-5@2x.bd401659.png";